import { useSearchParams } from 'react-router-dom';
import { applySearchParamPatch } from '../AnalysisWorkspace/workspaceUrlState.utils';
import { INGEST_PANEL, INGEST_SEARCH_PARAMS } from './ingestion.constants';

/** Opens the "Extract transaction from document" modal on its upload panel (a history entry, so Back closes it). */
export const useOpenIngestion = (): (() => void) => {
	const [, setSearchParams] = useSearchParams();

	return () =>
		setSearchParams((current) =>
			applySearchParamPatch(current, {
				[INGEST_SEARCH_PARAMS.panel]: INGEST_PANEL.UPLOAD,
				[INGEST_SEARCH_PARAMS.batch]: null,
			})
		);
};
